var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCategoriesScrollArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25px",
    height: "25px",
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M580 2243 c-51 -19 -79 -78 -60 -129 6 -17 214 -233 490 -509 l480 -480 -480 -480 c-331 -331 -483 -490 -491 -512 -27 -83 61 -160 137 -120 48 26 1072 1058 1079 1089 4 15 4 37 0 50 -8 27 -1037 1063 -1077 1084 -28 14 -52 17 -78 7z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriesScrollArrow);
export default __webpack_public_path__ + "static/media/categories-scroll-arrow.b077f54d.svg";
export { ForwardRef as ReactComponent };